import {ChangeDetectionStrategy, Component, inject} from "@angular/core";
import {SessionModel} from "../../session/session.model";
import {NavigationService} from "../../navigation/navigation.service";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {QrCodePageComponent} from "../../ui-elements/qr-code/qr-code-page/qr-code-page.component";
import {QrCodePanelComponent} from "../../ui-elements/qr-code/qr-code-panel/qr-code-panel.component";
import {ConfigurationModel} from '../../configuration/configuration.model';
import {IdentityModel} from '../identity.model';
import {ActivatableDirective} from '../../ui-elements/activatable.directive';

@Component({
    selector: "woa-member-card-panel",
    templateUrl: "./member-card-panel.component.html",
    styleUrl: "./member-card-panel.component.scss",
    imports: [
        QrCodePanelComponent,
        TranslateModule,
        ActivatableDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MemberCardPanelComponent {
    public configurationModel: ConfigurationModel = inject(ConfigurationModel);
    public sessionModel: SessionModel = inject(SessionModel);
    public identityModel: IdentityModel = inject(IdentityModel);
    private navigationService: NavigationService = inject(NavigationService);
    private translate: TranslateService = inject(TranslateService);

    async showQrCode(): Promise<void> {
        if (this.identityModel.currentMember() && ((this.identityModel.currentMember().memberCardNo && !this.identityModel.currentMember().integratedLoyaltyId) || this.identityModel.currentMember().integratedCardNo)) {
            return QrCodePageComponent.showQrCode(this.navigationService,
                this.identityModel.currentMember().integratedCardNo || this.identityModel.currentMember().memberCardNo,
                this.translate.instant("woa.label.member.qrCode"));
        }
    }
}
